<template>
  <div class="container container-table">
    <div class="row">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-solid box-info">
            <div>
              <div class="box-body">
                <div class="row">
                  <div style="width:224px;margin:auto;">
                    <img src="../../src/assets/img/account/developer.png" class="center-block1">
                  </div>
                  <div style="test_all">
                    <div class="text-center col-md-4 col-sm-offset-4 container">
                      <form class="ui form loginForm container">
                        <div class="input-group">
                          <input
                            @input="inputFocusChange"
                            @focus="inputfocus"
                            :class="response ? input_border : ''"
                            class="form-control input_form"
                            ref="loginEmail"
                            name="email"
                            placeholder="Email"
                            type="text"
                            v-model="email"
                            :onKeypress="onkeyPress"
                          >
                        </div>

                        <div class="input-group">
                          <input
                            @input="inputFocusChange"
                            :style="spacing"
                            @focus="inputfocus"
                            :class="response ? input_border : ''"
                            class="form-control input_form"
                            name="password"
                            placeholder="Password"
                            type="password"
                            v-model="password"
                            :onKeypress="onkeyPress"
                          >
                        </div>

                        <div class="input_error_response" v-show="error_response_flag">
                          <p class="error_response_p">{{response}}</p>
                        </div>
                        <div class="checkbox_div">
                          <label @click="remenber_me_btn" class="label_class" :style="border_style">
                            <img :src="src" class="Remember_me_image">
                          </label>
                          <span
                            @click="remenber_me_btn"
                            class="Remember_me"
                          >{{$t('developer_account_remember_me')}}</span>
                          <span style="display:flex;flex-grow:1;"></span>
                          <span
                            class="Forget_password"
                            @click="btn_forget_password"
                          >{{$t('developer_account_forget_password')}}</span>
                        </div>

                        <div class="input-group div_btn_login_border">
                          <button
                            :disabled="disabled"
                            :class=" { red:changeRed == true } "
                            class="btn_login"
                            @click.stop.prevent="checkCreds"
                          >{{$t('indexLogin')}}</button>
                          <span class="btn_login_border" v-show="changeRed"></span>
                        </div>
                      </form>

                      <div style="width: 37em;margin:auto;">
                        <p class="Join-NUWA-developer">{{$t('developer_account_join_developer')}}</p>
                      </div>
                      <div class="div_signin">
                        <button
                          class="btn_signin"
                          @click="registerNuwaDevelop"
                        >{{$t('indexRegister')}}</button>
                      </div>
                    </div>
                    <LoginFooter/>
                  </div>
                </div>

                <br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import config from '../config'
import LoginFooter from '@/views/LoginFooter.vue'
export default {
    name: 'Login',
    components: {
        LoginFooter
    },
    data (router) {
        return {
            section: 'Login',
            loading: '',
            email: '',
            password: '',
            response: null,
            spacing: '',
            input_border: 'input_border',
            checkbox_flag: false,
            changeRed: false,
            focus_flag: false,
            disabled: true,
            src: require('../../src/assets/img/account/Account_1.gif'),
            border_style: '',
            creat_account_flag: false,
            error_response_flag: false,
            onkeyPress:
                'javascript:if(event.keyCode == 32)event.returnValue = false;',
            terms: 'https://user-privacy.nuwarobotics.cn/zh-tw/terms.html',
            pricacy: 'https://user-privacy.nuwarobotics.cn/zh-tw/privacy.html'
        }
    },
    mounted () {
        this.$store.state.isFooterShow = false
        this.$refs.loginEmail.focus()
        if (localStorage.remember_checkbox === 'true') {
            this.email = localStorage.login_email
            this.checkbox_flag = localStorage.remember_checkbox
            this.src = require('../../src/assets/img/account/Account.gif')
            this.border_style = 'border:none;'
        } else {
            this.password = ''
            this.email = ''
        }
    },
    methods: {
        inputFocusChange () {
            if (!this.response) {
                return
            }
            this.response = null
        },
        btn_forget_password () {
            this.$store.state.borderStyle = null
            localStorage.setItem('clickState', null)
            this.$router.push({ name: 'forgetPassword' })
        },
        registerNuwaDevelop () {
            this.$store.state.borderStyle = null
            localStorage.setItem('clickState', null)
            this.$router.push({ path: '/user/register' })
        },
        reds () {
            this.changeRed = true
        },
        checkCreds () {
            this.focus_flag = false
            this.changeRed = true
            this.registerToken()
        },
        successClick () {
            let registeredFlag = sessionStorage.getItem('registeredDetail')
            if (registeredFlag === 'true') {
                this.$store.state.borderStyle = null
                localStorage.setItem('clickState', null)
                // this.$router.push({ name: "listApp" });
                this.$router.push({ name: 'MyProjectsList' })
            } else {
                // console.log('verifyEmail')
                localStorage.setItem('clickState', null)
                this.$store.state.borderStyle = null
                this.$router.push({ name: 'verifyEmail' })
            }
        },
        registerDetail () {
            const path =
                'developer/user/account/info'
            this._api.request('get', path)
                .then(response => {
                    if (
                        response.status === 200 &&
                        response.data.data.payload.status === 'confirmed' && response.data.data.payload.type &&
                        response.data.data.payload.firstName
                    ) {
                        sessionStorage.setItem(
                            'registeredDetail',
                            JSON.stringify(true)
                        )
                        this.$store.state.registeredDetail = 'true'
                        this.$store.state.borderStyle = 'file'
                        localStorage.setItem('clickState', 'file')
                    } else {
                        sessionStorage.setItem(
                            'registeredDetail',
                            JSON.stringify(false)
                        )
                        this.$store.state.registeredDetail = 'false'
                        if (response.status === 200 && response.data.data.payload.type) {
                            localStorage.setItem('tempType', response.data.data.payload.type)
                        }
                    }
                    this.successClick()
                })
                .catch(error => {
                    console.log(error)
                    sessionStorage.setItem(
                        'registeredDetail',
                        JSON.stringify(false)
                    )
                    this.$store.state.registeredDetail = 'false'
                })
        },
        registerToken () {
            const { email, password } = this
            this.toggleLoading()
            this.resetResponse()
            const path =
                'developer/user/login/verify'
            /* Making API call to authenticate a user */
            this._api.request('post', path, { email, password })
                .then(response => {
                    this.toggleLoading()
                    var data = response.data.data
                    /* Checking if error object was returned from the server */
                    if (data.error) {
                        var errorName = data.error.name
                        if (errorName) {
                            this.response =
                                errorName === 'InvalidCredentialsError'
                                    ? this.$t('loginError')
                                    : errorName
                        } else {
                            this.response = data.error
                        }
                        return
                    }
                    var token = 'Bearer ' + data.token
                    var user = data.email
                    if (window.localStorage) {
                        window.localStorage.setItem('token', token)
                        window.localStorage.setItem('user', user)
                    }
                    // 把点击状态存储到 localStorage
                    localStorage.remember_checkbox = this.checkbox_flag
                    localStorage.login_email = this.email
                    this.registerDetail()
                })
                .catch(error => {
                    console.log(error)
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.status >= 400
                    ) {
                        this.response = this.$t('loginError')
                    } else {
                        this.response = this.$t('serverAppears')
                    }
                    this.toggleLoading()
                })
        },
        toggleLoading () {
            this.loading = this.loading === '' ? 'loading' : ''
        },
        resetResponse () {
            this.response = ''
        },
        inputfocus () {
            this.resetResponse()
            this.focus_flag = true
        },
        remenber_me_btn (flag) {
            this.checkbox_flag = !this.checkbox_flag
            localStorage.setItem('remember_checkbox', flag)
            if (this.checkbox_flag) {
                this.src = require('../../src/assets/img/account/Account.gif')
                this.border_style = 'border:none;'
            } else {
                this.src = require('../../src/assets/img/account/Account_1.gif')
                this.border_style = ''
            }
        },
        register_page () {
            this.$router.push({ name: 'userRegister' })
        }
    },
    // 使用生命周期函数 实现input框样式
    beforeUpdate () {
        // 这是在判断 是否加密码框的字间距
        if (this.password === '' || this.password === undefined) {
            this.spacing = ''
        } else {
            this.spacing = 'letter-spacing: .8em'
        }
        if (this.response) {
            this.changeRed = false
            this.disabled = true
            this.creat_account_flag = true
            this.error_response_flag = true
        } else if (this.password === '' || this.email === '') {
            this.changeRed = false
            this.disabled = true
        } else {
            this.changeRed = true
            this.disabled = false
            this.error_response_flag = false
        }
    },
    destroyed () {
        this.$store.state.isFooterShow = true
    }
}
</script>
<style scoped>
.btn_login_border {
    width: 201.5px;
    height: 2px;
    background: rgba(51, 51, 51, 0.3);
    /* border: solid 1px rgba(51, 51, 51, 0.3); */
    position: absolute;
    left: 10px;
    top: 51px;
}
.div_btn_login_border {
    position: relative;
}
.container {
    -webkit-user-select: none;
    user-select: none;
}
.Remember_me_image {
    width: 100%;
    height: 100%;
}
.div_creat_account {
    width: 30.7em;
    height: 5.57em;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.3);
    border: solid 2.5px rgba(0, 181, 226, 0.5);
    margin: auto;
    margin-top: 13.5em;
    margin-bottom: -20.6em;
    cursor: pointer;
}
.span_creat_account {
    width: 21.4em;
    height: 2.35em;
    font-family: sans-serif;
    font-size: 22px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.2px;
    text-align: center;
    color: #00b5e2;
    line-height: 3em;
}
.error_response_p {
    margin: 0;
}
.input_error_response {
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: rgba(246, 70, 53, 0.5);
    margin: auto;
    margin-top: -0.6em;
    padding-bottom: 0.9em;
    width: 333px;
    text-align: left;
}
.label_class {
    width: 1.7em;
    height: 1.8em;
    border: 1px solid rgba(51, 51, 51, 0.3);
    border-radius: 2px;
    margin-top: -0.3em;
    cursor: pointer;
    box-sizing: border-box;
}
.red {
    background-color: #00b5e2 !important;
    opacity: 1 !important;
}
.btn_signin {
    width: 10em;
    height: 2.4em;
    outline: none;
    border: 2px solid #00b5e2;
    background: white;
    color: #00b5e2;
    font-size: 22px;
    cursor: pointer;
    border-radius: 10px;
    letter-spacing: 1.2px;
    font-weight: bold;
}
.btn_signin:hover {
    background-color: rgba(255, 255, 255, 0.5);
}
.btn_login {
    width: 10em;
    height: 2.4em;
    outline: none;
    border: 0;
    border-radius: 10px;
    font-size: 22px;
    margin-bottom: 1em;
    letter-spacing: 1.2px;
    font-weight: bold;
    cursor: pointer !important;
    background-color: rgba(51, 51, 51, 0.2);
    color: #ffffff;
}
.loading {
    font-size: 18px;
}
.btnStyle {
    background: #00b5e2;
    color: #ffffff;
}
.input_border {
    border-color: #f64635 !important;
    color: #f64635 !important;
}
html,
body,
.container-table {
    height: 100%;
    background-color: white !important;
}
.vertical-center-row {
    display: table-cell;
    vertical-align: middle;
}
.vertical-20p {
    padding-top: 20%;
}
.vertical-10p {
    padding-top: 10%;
}
.logo {
    width: 15em;
    padding: 3em;
}
.loginForm .input-group {
    padding-bottom: 1em;
    height: 0;
}
.input-group input {
    height: 2.7em;
}
#userLoginSubmitButton {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    height: 100%;
    outline: none;
}
/* [fu] */

/* 取消边框 */
.box.box-solid.box-info {
    border: none;
}
.vertical-10p {
    padding-top: 0 !important;
}
.center-block1 {
    padding-bottom: 3.5em !important;
    margin-top: 50px;
}
.box-body {
    padding-top: 0;
}
/* input */
.input-group input {
    width: 23.8em !important;
    border-radius: 12px !important;
    border: 1px solid rgba(51, 51, 51, 0.5);
    color: #333333;
}
.input-group {
    margin: auto;
    font-weight: bold;
}
/* form剧中 */
.col-sm-offset-4 {
    margin: auto;
    width: 100%;
}
.checkbox_div {
    display: flex;
    margin-left: 2em;
    margin-bottom: 3.5em;
    width: 23.8em;
    margin: auto;
    padding-bottom: 2.8em;
    margin-top: 0.3em;
    position: relative;
}
/* 这是button */
.btn-info {
    background-color: rgba(51, 51, 51, 0.2);
    border: none;
    width: 10em !important;
    margin-left: 33%;
    border-radius: 8px !important;
    font-size: 22px !important;
    height: 50px !important;
    margin-bottom: 1.5em !important;
    margin: auto;
}
.div_signin {
    width: 37em;
    padding-top: 3.2em;
    margin: auto;
}

/* input的字体大小 */
.form-control {
    padding: 6px 24px;
    font-size: 18px;
}
.Forget_password {
    height: 20px;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #333333;
}
.Remember_me {
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 19px;
    letter-spacing: 0.8px;
    color: #333333;
    padding-left: 10px;
}
.Remember_me {
    cursor: pointer;
}
.checkbox_class {
    cursor: pointer;
}
.Forget_password {
    cursor: pointer;
}
/* 加form的上下border */
.ui {
    width: 37em;
    border-bottom: 2px solid rgba(0, 224, 218, 0.3);
    border-top: solid 2px rgba(51, 51, 51, 0.1);
    padding-top: 2.7em;
}
.box {
    box-shadow: none;
    margin-bottom: 0;
}
.box-body {
    padding-bottom: 0;
}
.Join-NUWA-developer {
    width: 164px;
    height: 20px;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: rgba(51, 51, 51, 0.5);
    margin: auto;
    padding-top: 1.9em;
}

/* 底部 */
.Copyright-2018-Nuw {
    width: 400px;
    height: 20px;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    margin-left: 1em;
    color: #333333;
}
.copyright_a {
    color: #333333;
}
.copyright_a:hover {
    color: #333333;
}
.Login-Page_Link {
    height: 20px;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #333333;
}
.Login-Page_Link a {
    padding: 0 18px;
    color: #333333;
}
.Login-Page_Link a:not(:last-child) {
    border-right: 1px solid;
}
.input_form {
    width: 380px;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.2px;
    color: rgba(51, 51, 51, 0.3);
}
.div_footer {
    display: flex;
    clear: both;
    margin: auto;
    padding-top: 25.8em;
    width: 57em;
}
#app {
    background: rgba(0, 181, 226, 0.1);
}

/* [新增] */
.container {
    margin: auto;
}
.label_class {
    width: 21.8px;
    height: 23.2px;
}
.input-group {
    position: relative;
    display: table;
    border-collapse: separate;
}
.btn_signin {
    display: block;
    margin: auto;
}
.Join-NUWA-developer {
    text-align: center;
}
.input-group input {
    outline: none;
    height: 1.7em !important;
    width: 20.2em !important;
}
.checkbox_div {
    width: 20.2em !important;
}
/* 新增 */
</style>
